import { render, staticRenderFns } from "./MerchantListItem.vue?vue&type=template&id=4ef4cc10&scoped=true&"
import script from "./MerchantListItem.vue?vue&type=script&lang=ts&"
export * from "./MerchantListItem.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantListItem.vue?vue&type=style&index=0&id=4ef4cc10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef4cc10",
  null
  
)

export default component.exports